var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPapelNotificacao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.915,
    height: 19.338,
    viewBox: "0 0 15.915 19.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1542",
    "data-name": "Ret\\xE2ngulo 1542",
    width: 15.915,
    height: 19.338,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4101",
    "data-name": "Grupo 4101",
    transform: "translate(15.915 19.338) rotate(180)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1843",
    "data-name": "Caminho 1843",
    d: "M11.631,19.238h0a.361.361,0,0,0,.248-.1L15.743,15.5a.359.359,0,0,0,.11-.26.419.419,0,0,0,.062-.217V1.525A1.527,1.527,0,0,0,14.39,0H1.525A1.527,1.527,0,0,0,0,1.525V17.812a1.527,1.527,0,0,0,1.525,1.525h9.835a.419.419,0,0,0,.27-.1m.362-1.2v-1.4a1.048,1.048,0,0,1,1.047-1.047h1.548Zm-1.056.449H1.525a.68.68,0,0,1-.679-.679V1.525A.68.68,0,0,1,1.525.847H14.39a.679.679,0,0,1,.679.679V14.6H13.091a2.157,2.157,0,0,0-2.154,2.154Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1844",
    "data-name": "Caminho 1844",
    d: "M9.82,1.2H.291A.291.291,0,0,1,0,.91V.291A.291.291,0,0,1,.291,0H9.82a.291.291,0,0,1,.291.291V.91A.291.291,0,0,1,9.82,1.2",
    transform: "translate(2.872 3.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1845",
    "data-name": "Caminho 1845",
    d: "M9.82,1.2H.291A.291.291,0,0,1,0,.91V.291A.291.291,0,0,1,.291,0H9.82a.291.291,0,0,1,.291.291V.91A.291.291,0,0,1,9.82,1.2",
    transform: "translate(2.872 6.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1846",
    "data-name": "Caminho 1846",
    d: "M9.82,1.2H.291A.291.291,0,0,1,0,.91V.291A.291.291,0,0,1,.291,0H9.82a.291.291,0,0,1,.291.291V.91A.291.291,0,0,1,9.82,1.2",
    transform: "translate(2.872 8.943)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapelNotificacao);
export default __webpack_public_path__ + "static/media/papelNotificacao.9502eab859b3ac4894b8aa05a673c2bc.svg";
export { ForwardRef as ReactComponent };